import React, { useEffect, useState } from 'react'
import { Input } from "antd";
import TableWithSkeleton from '../../components/global/table/TableWithSkeleton'
import Pagination from '../../components/global/pagination/Pagination';
import columns from '../../columns/tncReport';
import { GetTermsAndConditionReportApi } from '../../api/request/tnc';
import moment from 'moment/moment';
import UserAvatar from '../../components/global/avtar/UserAvatar';

const TNCReport = () => {
    const [pageSize, setPageSize] = useState(10);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [searchText, setSearchText] = useState('');
    const [totalRecord, setTotalRecord] = useState(0);
    const [search, setSearch] = useState('');

    const getTncReport = async () => {
        try {
            let params = {
                PageNumber: page,
                PageSize: pageSize,
                SearchText: searchText,
            }
            setLoading(true);
            const { data } = await GetTermsAndConditionReportApi(new URLSearchParams(params).toString());
            if (data?.success) {
                const mapped = (data.data || []).map((item) => {
                    const docs = Array.isArray(item?.termsAndConditions)
                        ? item.termsAndConditions.map((d, i) => {
                            const url = String(d?.fileUrl || "").replace(/[`]/g, "").trim();
                            return url ? (
                                <a key={d?.id || i} href={url} target="_blank" rel="noreferrer" className="primary hover:underline duration-300" >
                                    {d?.fileName || "Document"}
                                </a>
                            ) : (
                                <span key={d?.id || i}>--</span>
                            );
                        })
                        : [];
                    return {
                        ...item,
                        user: <UserAvatar data={{ name: item?.fullName, email: item?.email }} />,
                        documents: docs.length > 0 ? <div className="flex flex-wrap gap-2">{docs}</div> : "--",
                        acceptedDate: moment(item?.acceptedDate).format("DD-MM-YYYY, LT"),
                    };
                });
                setData(mapped);
                setTotalRecord(data?.totalRecords);
            }
        } catch (error) { }
        finally {
            setLoading(false);
        }
    }



    useEffect(() => {
        getTncReport();
    }, [page, pageSize, searchText]);

    useEffect(() => {
        setPage(1);
    }, [searchText]);

    return (
        <div>
            <div className="flex justify-end flex-wrap gap-5">
                <div className="flex flex-wrap items-center gap-3">
                    <div>
                        <Input
                            size="large"
                            style={{ width: 220 }}
                            placeholder="Search"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            onPressEnter={() => setSearchText(search)}
                            prefix={
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                                    <path fillRule="evenodd" d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z" clipRule="evenodd" />
                                </svg>
                            }
                            suffix={search &&
                                <svg xmlns="http://www.w3.org/2000/svg" onClick={() => { setSearchText(''); setSearch('') }} viewBox="0 0 24 24" fill="#bebebe" className="size-5 cursor-pointer duration-300 hover:fill-[#969595]">
                                    <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z" clipRule="evenodd" />
                                </svg>
                            }
                        />
                    </div>
                </div>
            </div>

            <div className="my-6">
                <div className="border border-gray-200 rounded-xl overflow-hidden bg-white">
                    <TableWithSkeleton
                        columns={columns}
                        data={data}
                        loading={loading}
                        page={page}
                        pageSize={pageSize}
                        index={true}
                    />
                </div>
                <Pagination total={totalRecord} pageSize={pageSize} setPageSize={setPageSize} page={page} setPage={setPage} />
            </div>
        </div>
    )
}

export default TNCReport